'use strict';

import GoogleMap from 'google-map-react-cn';

import React from 'react';
import MapMarker from './MapMarkerComponent';
import {Link,browserHistory} from 'react-router';
import MediaStore from 'stores/MediaStore';
import Header from './HeaderComponent';
import API from 'sources/API';

import 'styles/MapDetail.scss';

function createMapOptions(maps) {
  return {
    zoomControlOptions: {
      position: maps.ControlPosition.RIGHT_CENTER,
      style: maps.ZoomControlStyle.SMALL
    },
    mapTypeControlOptions: {
      position: maps.ControlPosition.TOP_RIGHT
    },
    mapTypeControl: true
  };
}
const defaultCenter = [59.938043, 30.337157];
class MediaDetailComponent extends React.Component {

  constructor(props) {
    super(props);
    let mediaStore = MediaStore.getState();
    this.state = {
      center: [mediaStore.lat,mediaStore.lng],
      zoom: 12
    };
    this.gotoBack = this.gotoBack.bind(this); // 数据有变
    this.onMediaChange = this.onMediaChange.bind(this);
  }
  gotoBack() {
	  browserHistory.goBack();
  }
  componentDidMount() {
	  MediaStore.listen(this.onMediaChange);
  }
  componentWillUnmount() {
	  MediaStore.unlisten(this.onMediaChange);
  }
  onMediaChange(media) {
  	this.setState({
      center: [media.lat,media.lng]
    });
  }

  render() {
  	return (
  	  <div className="map-component">
  	    <Header title="坐标" />
    		<div className="map">
    		  <GoogleMap
    	        bootstrapURLKeys={{key: API.getMapAPIKey}}
    	        center={this.state.center}
    	        zoom={this.state.zoom}
    	        options={createMapOptions}>
    	        <MapMarker lat={this.state.center[0]} lng={this.state.center[1]} text={'D'}/>
    		  </GoogleMap>
    	  </div>
  	  </div>
  	)
  }
}

// Uncomment properties you need
// MediaDetailComponent.propTypes = {}
// MediaDetailComponent.defaultProps = {};

export default MediaDetailComponent;



// WEBPACK FOOTER //
// ./src/components/MapDetailComponent.js